import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';

import authReducer from 'store/reducers/auth';
import chatReducer from 'store/reducers/chat';
import childrenReducer from 'store/reducers/children';
import commonReducer from 'store/reducers/common';
import facilityReducer from 'store/reducers/facility';
import languageReducer from 'store/reducers/language';
import profileReducer from 'store/reducers/profile';
import reportReducer from 'store/reducers/report';
import sampleVideoReducer from 'store/reducers/sample-video';
import surveyReducer from 'store/reducers/survey';
import videoCategoryReducer from 'store/reducers/video-catergory';

const rootReducer = combineReducers({
  auth: authReducer,
  profile: profileReducer,
  common: commonReducer,
  survey: surveyReducer,
  report: reportReducer,
  sampleVideo: sampleVideoReducer,
  videoCategory: videoCategoryReducer,
  facility: facilityReducer,
  language: languageReducer,
  children: childrenReducer,
  chat: chatReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
